<div class="group-header row pl-3 m-0" [hidden]="headerInfo?.groupId == ''">
    <div class="col col-5">
        <p>Group Name</p><strong>{{headerInfo?.groupName}}</strong>
    </div>
    <div class="col">
        <p>Group ID</p><strong>{{headerInfo?.groupId}}</strong>
    </div>
    <div class="col" *ngIf="headerInfo?.members > 0">
        <p>Members</p><strong>{{headerInfo?.members}}</strong>
    </div>
    <div class="col" *ngIf="headerInfo?.members == 0">
        <p>Members</p><strong>--</strong>
    </div>
    <div class="col">
        <p>Due Date</p><strong>{{headerInfo?.dueDate}}</strong>
    </div>
    <div class="col" *ngIf="headerInfo?.amountDue > 0">
        <p>Amount Due</p>
        <strong>{{headerInfo?.amountDue | currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
    </div>
    <div class="col" *ngIf="headerInfo?.amountDue == 0">
        <p>Amount Due</p>
        <strong>--</strong>
    </div>

    <!-- <div class="col-xs-8 col-xs-8"><p>Group Name</p><strong>Pediatric Emergency Medicine Faculty</strong></div>
            <div class="col-xs-1 col-xs-1"><p>Group ID</p><strong>A1324654</strong></div>
            <div class="col-xs-1 col-xs-1"><p>Members</p><strong>60</strong></div>
            <div class="col-xs-1 col-xs-1"><p>Due Date</p><strong>4/30/2019</strong></div>
            <div class="col-xs-1 col-xs-1"><p>Amount Due</p><strong>$520.00</strong></div> -->
</div>
<div *ngIf="errorExists" class="row pl-4 my-2">
    <p class="error"><b>{{errorMessage}}</b></p>
</div>
